import React from 'react';
import ReactImageFallback from "react-image-fallback";

import userDefaultImage from '../assets/images/user.svg';

function CUserImageIcon(props) {
    const { src } = props;
    let imageUrl = src || '';
    return (
        <ReactImageFallback
            src={imageUrl}
            fallbackImage={userDefaultImage}
            initialImage={userDefaultImage}
            alt="user image"
            className="my-image"/>
    );
}

export default CUserImageIcon;
